export default __webpack_public_path__ + "media/images/file_types/svg-0070a5c654f6e5f21068b549fefddbbd.svg";